module.exports = __webpack_public_path__ + "img/Group 26848@2x.8095237d.png";